// Modules
import React, { useContext, useState } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import PropTypes from "prop-types";

// Import Swiper styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";

// Context
import ApiContext from "../../contexts/ApiContext";

// Local
import Map from "../utils/Map";
import Divider from "../utils/Divider";
import Tooltip from "../utils/Tooltip";

// Assets
import "./neighborhood-analyse.scss";
import CloseIcon from "../../assets/img/svg/Close_icon.jsx";
import LogoSecondary from "../../assets/img/svg/LogoSecondary";

const NeighborhoodAnalyse = (props) => {
  const { data, loader, imagesArr } = props;
  const {
    arg_q1,
    arg_q2,
    arg_q3,
    ville,
    quartier,
  } = data;
  const { isMobile, isTablet } = useContext(ApiContext);
  const [fullScreen, setFullScreen] = useState(null);

  return (
    <React.Fragment>
      <Divider text="Le quartier" loader={loader} />
      <div className={`neighborhood-analyse-container ${isMobile === true || isTablet === true ? "mobile" : ""}`}>
        <div className="first-column">
          <Map
            className="map-container"
            latitude={data.latitude}
            longitude={data.longitude}
            ville={ville ?? ""}
            loader={loader}
          />
        </div>
        <div className="second-column">
          {loader
            ? (
              <div className="neighborhood-infos-wrapper">
                <Skeleton variant="rect" width="80vh" height="30vh" />
              </div>
            )
            : (
              <div className="neighborhood-infos-wrapper">
                <div className="neighborhood-container">
                  <h5 className="title">Les + du quartier :</h5>
                  <ul className="arguments-list">
                    <li>{arg_q1}</li>
                    <li>{arg_q2}</li>
                    <li>{arg_q3}</li>
                  </ul>
                </div>
              </div>
            )}
          <div className="images-container">
            {imagesArr.length > 0 && loader === false
              ? (
                <div className="images-wrapper">
                  {imagesArr.map((img, index) => {
                    if ((index < 2 && isMobile === false && isTablet === false)
                      || (index > 0 && index <= 2 && (isMobile === true || isTablet === true)))
                      return (
                        <div
                          style={{ backgroundImage: `url(${img})` }}
                          title={quartier}
                          className="neighborhood-image"
                          key={img}
                          onClick={() => setFullScreen(img)}
                        />
                      );
                    else if ((index === 2 && isMobile === false && isTablet === false)
                      || (index === 0 && (isMobile === true || isTablet === true)))
                      return (
                        <React.Fragment key={`${img}-fragment`}>
                          <div className="legend" key={`${img}-legend`}>
                            <h6>Légende</h6>
                            <ul>
                              <li>
                                <span className="iris-color" />
                                Placement
                              </li>
                              <li>
                                <span className="iris-color" />
                                Équilibrée
                              </li>
                              <li>
                                <span className="iris-color" />
                                Développement
                              </li>
                              <li>
                                <Tooltip
                                  visibleText={(
                                    <React.Fragment>
                                      <LogoSecondary clssName="logo" />
                                      Projet Bevouac
                                    </React.Fragment>
                                  )}
                                  tooltipText="Tous ces projets présentés ne sont pas des opportunités disponibles actuellement sur le marché, mais des projets réalisés par Bevouac par le passé."
                                  keyProp="bevouac-projects-descr"
                                  className="bevouac-projects"
                                />
                              </li>
                            </ul>
                          </div>
                          <div
                            style={{ backgroundImage: `url(${img})` }}
                            title={quartier}
                            className="neighborhood-image"
                            key={img}
                            onClick={() => setFullScreen(img)}
                          />
                        </React.Fragment>
                      );
                    return null;
                  })}
                  {imagesArr.length === 2 && isMobile === false && isTablet === false
                    ? (
                      <div className="legend" key="legend">
                        <h6>Légende</h6>
                        <ul>
                          <li>
                            <span className="iris-color" />
                            Placement
                          </li>
                          <li>
                            <span className="iris-color" />
                            Équilibrée
                          </li>
                          <li>
                            <span className="iris-color" />
                            Développement
                          </li>
                          <li>
                            <Tooltip
                              visibleText={(
                                <React.Fragment>
                                  <LogoSecondary clssName="logo" />
                                  Projet Bevouac
                                </React.Fragment>
                              )}
                              tooltipText="Tous ces projets présentés ne sont pas des opportunités disponibles actuellement sur le marché, mais des projets réalisés par Bevouac par le passé."
                              keyProp="bevouac-projects-descr"
                              className="bevouac-projects"
                            />
                          </li>
                        </ul>
                      </div>
                    ) : null}
                </div>
              ) : null}
          </div>
        </div>
        {fullScreen !== null
          ? (
            <div className="modal-container">
              <div className="background" onClick={() => setFullScreen(null)} />
              <div className="modal-content">
                <CloseIcon clssName="close-icon" onClick={() => setFullScreen(null)} />
                <div
                  style={{ backgroundImage: `url(${fullScreen})` }}
                  className="neighborhood-image-full-screen"
                  onClick={() => setFullScreen(null)}
                />
              </div>
            </div>
          ) : null}
      </div>
    </React.Fragment>
  );
};

NeighborhoodAnalyse.propTypes = {
  loader: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  imagesArr: PropTypes.array.isRequired,
};

export default NeighborhoodAnalyse;
